export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7979.b53bcf73.jpg";